import { render, staticRenderFns } from "./addPerm.vue?vue&type=template&id=fda1b002&scoped=true&"
import script from "./addPerm.vue?vue&type=script&lang=js&"
export * from "./addPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda1b002",
  null
  
)

export default component.exports